import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import $ from "jquery";
import { SnackbarProvider } from "notistack";
import ReactDOM from "react-dom/client";
import { Login } from "./main/utilities/auth/Login";
import theme from "./theme";
const root = ReactDOM.createRoot(document.getElementById("root"));
window.$ = $;
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 0,
      refetchOnWindowFocus: true,
      refetchOnMount: true,
    },
  },
});

root.render(
  <SnackbarProvider maxSnack={3}>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Login />
      </ThemeProvider>
    </QueryClientProvider>
  </SnackbarProvider>
);
